module.exports = __webpack_public_path__ + "static/img/rmc-logo.026de44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rmc-logo.png
// module id = kRkX
// module chunks = 1